export default __webpack_public_path__ + "static/media/J750_RoHS.af9a1ce1.pdf";